import { AIAssistantClientSkillSchema, AIAssistantClientSkillsSchema, type AIAssistantClientSkill } from 'balus-common';
import * as v from 'valibot';

const VIEW_MODEL_SKILLS_KEY_PREFIX = 'balus.aiAssistant.viewModelSkills.v1.';

function storageKey(viewModelId: string): string {
  return `${VIEW_MODEL_SKILLS_KEY_PREFIX}${viewModelId}`;
}

function parseSkills(value: unknown): AIAssistantClientSkill[] {
  if (!Array.isArray(value)) return [];

  const skills: AIAssistantClientSkill[] = [];
  for (const item of value) {
    const parsed = v.safeParse(AIAssistantClientSkillSchema, item);
    if (parsed.success) {
      skills.push(parsed.output);
    }
  }
  return skills.slice(0, 20);
}

export class ViewModelLocalSkillStorage {
  static getSkills(viewModelId: string): AIAssistantClientSkill[] {
    const raw = localStorage.getItem(storageKey(viewModelId));
    if (!raw) return [];

    try {
      return parseSkills(JSON.parse(raw));
    } catch {
      return [];
    }
  }

  static getEnabledSkills(viewModelId: string): AIAssistantClientSkill[] {
    return this.getSkills(viewModelId).filter((skill) => skill.enabled);
  }

  static setSkills(viewModelId: string, skills: AIAssistantClientSkill[]): void {
    const parsed = v.safeParse(AIAssistantClientSkillsSchema, skills);
    if (!parsed.success) {
      throw new Error('Invalid view model local skills');
    }

    localStorage.setItem(storageKey(viewModelId), JSON.stringify(parsed.output));
  }

  static removeSkills(viewModelId: string): void {
    localStorage.removeItem(storageKey(viewModelId));
  }
}
